<template>
  <div class="blessing-bag-item cursor-pointer" :style="blessingStyle">
    <div class="blessing-bag-label-wrap" :style="wrapStyle">
      <span class="whitespace-nowrap">{{ item.label }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BlessingBagItem',
  props: {
    item: {
      type: Object,
      default: () => ({})
    }
  },
  computed:{
    wrapStyle(){
      const blessingConfig = this.$bus.survey.otherSetting.blessingConfig || {}
      return {
        top: blessingConfig.labelTop || '50%',
        left: blessingConfig.labelLeft || '50%'
      }
    },
    blessingStyle(){
      const blessingConfig = this.$bus.survey.otherSetting.blessingConfig
      if(!blessingConfig) return {}
      return {
        width: blessingConfig.imageWidth,
        height: blessingConfig.imageHeight,
        'background-image': `url(${blessingConfig.image})`
      }
    }
  }
}
</script>

<style scoped>
.blessing-bag-item {
  background-image: url(./assets/blessing-bag.png);
  background-repeat: no-repeat;
  background-size: contain;
  width: 74px;
  height: 58px;
  position: relative;
}

.blessing-bag-label-wrap {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translateX(-50%);
  background-color: #e8d673;
  border-radius: 2px;
  padding: 2px;
}
</style>
